import React from "react";
import { ChevronDown, Gauge, ArrowRight } from "lucide-react";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-screen w-full flex items-end pb-24 pt-32 overflow-hidden"
        >
            {/* Background image */}
            <div className="absolute inset-0">
                <img
                    src="https://images.pexels.com/photos/14984574/pexels-photo-14984574.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080"
                    alt="Police chase"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-black/70 to-black/40" />
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(229,255,0,0.12),_transparent_60%)]" />
            </div>

            {/* Glow blobs */}
            <div className="absolute top-1/3 -left-20 w-[500px] h-[500px] glow-yellow pointer-events-none" />
            <div className="absolute bottom-10 right-10 w-[400px] h-[400px] glow-red pointer-events-none" />

            <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 w-full">
                <div className="flex flex-col gap-8">
                    {/* Top label */}
                    <div className="flex items-center gap-4">
                        <span className="h-px w-12 bg-neon-yellow" />
                        <span className="font-mono text-xs uppercase tracking-[0.3em] text-neon-yellow flicker">
                            ▸ Servidor BR · Online 24/7
                        </span>
                    </div>

                    {/* H1 */}
                    <h1
                        className="font-heading uppercase leading-[0.85] tracking-tighter"
                        style={{ fontSize: "clamp(4rem, 14vw, 13rem)" }}
                    >
                        <span className="block text-white">FORZA</span>
                        <span className="block text-neon-yellow">PILOTS</span>
                    </h1>

                    <div className="grid md:grid-cols-12 gap-8 items-end">
                        <div className="md:col-span-7">
                            <p className="text-lg md:text-2xl text-white/80 font-body max-w-xl leading-snug">
                                O maior servidor de{" "}
                                <span className="text-neon-yellow font-semibold">
                                    fugas e perseguições
                                </span>{" "}
                                do FiveM. Pisa fundo, dribla a viatura e mostra
                                quem manda no asfalto.
                            </p>
                        </div>

                        <div className="md:col-span-5 flex flex-col sm:flex-row gap-4 md:justify-end">
                            <a
                                href="#conectar"
                                data-testid="hero-connect-button"
                                className="group bg-neon-yellow text-black font-heading text-xl md:text-2xl uppercase px-7 py-4 inline-flex items-center justify-center gap-3 shadow-brutal-white"
                            >
                                Jogar Agora
                                <ArrowRight
                                    size={22}
                                    className="group-hover:translate-x-1 transition-transform"
                                />
                            </a>
                            <a
                                href="https://discord.gg/placeholder"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="hero-discord-button"
                                className="bg-transparent border-2 border-white text-white font-heading text-xl md:text-2xl uppercase px-7 py-4 hover:bg-white hover:text-black transition-colors inline-flex items-center justify-center gap-3"
                            >
                                Discord
                            </a>
                        </div>
                    </div>

                    {/* Stats strip */}
                    <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
                        {[
                            { v: "+2.4K", l: "Membros" },
                            { v: "128/128", l: "Slots" },
                            { v: "98ms", l: "Ping BR" },
                            { v: "24/7", l: "Online" },
                        ].map((s, i) => (
                            <div
                                key={i}
                                data-testid={`hero-stat-${i}`}
                                className="bg-[#0D0D0D] p-5 md:p-6 hover:bg-neon-yellow hover:text-black transition-colors group"
                            >
                                <div className="flex items-center gap-2 mb-1">
                                    <Gauge
                                        size={14}
                                        className="text-neon-yellow group-hover:text-black"
                                    />
                                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/60 group-hover:text-black/80">
                                        {s.l}
                                    </span>
                                </div>
                                <div className="font-heading text-3xl md:text-4xl">
                                    {s.v}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Scroll indicator */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 z-10">
                <span className="font-mono text-[10px] uppercase tracking-[0.3em]">
                    Acelera
                </span>
                <ChevronDown size={20} className="animate-bounce" />
            </div>
        </section>
    );
}
